import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a78ba5e8295d50014ca463e_1787550396079_b733d99f/yashcomputers/src/app/sign-up-login-screen/components/AuthScreen.tsx");
